import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Toaster } from "../components/ui/sonner";

const NavItem = ({ to, children, testId }) => (
  <NavLink
    to={to}
    data-testid={testId}
    className={({ isActive }) =>
      [
        "block px-4 py-3 text-sm font-sans border-l-2 transition-colors",
        isActive
          ? "border-klein text-ink bg-paper"
          : "border-transparent text-quiet hover:text-ink hover:bg-paper",
      ].join(" ")
    }
  >
    {children}
  </NavLink>
);

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-paper">
      <aside className="w-60 border-r border-rule bg-white sticky top-0 h-screen flex flex-col">
        <div className="px-4 py-6 border-b border-rule">
          <Link to="/" className="block" data-testid="brand-link">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-quiet">
              Internal Tool
            </div>
            <div className="font-serif text-2xl leading-none mt-1 text-ink">Recruit—Ops</div>
          </Link>
        </div>

        <nav className="flex-1 py-4">
          <div className="px-4 pb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-quiet">
            Pipeline
          </div>
          <NavItem to="/dashboard" testId="nav-dashboard">Dashboard</NavItem>
          <NavItem to="/requisitions" testId="nav-requisitions">Requisitions</NavItem>
          <NavItem to="/applicants" testId="nav-applicants">Candidates</NavItem>
          <NavItem to="/candidates" testId="nav-candidates">Stage</NavItem>
          <NavItem to="/reports" testId="nav-reports">Reports</NavItem>
          <NavItem to="/roster" testId="nav-roster">Roster</NavItem>
          <NavItem to="/employees" testId="nav-employees">Employees</NavItem>
          {user?.role === "hr" && (
            <NavItem to="/activity" testId="nav-activity">Activity Log</NavItem>
          )}

          <div className="px-4 pt-6 pb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-quiet">
            Account
          </div>
          {user?.role === "hr" && (
            <NavItem to="/settings/users" testId="nav-users">Users</NavItem>
          )}
          <NavItem to="/settings/email" testId="nav-email-settings">Email Setup</NavItem>
          {user?.is_super_admin && (
            <NavItem to="/settings/notifications" testId="nav-system-notifications">System Notifications</NavItem>
          )}
        </nav>

        <div className="border-t border-rule p-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-quiet mb-2">
            Signed in as
          </div>
          <div className="text-sm text-ink leading-tight" data-testid="current-user-name">
            {user?.full_name}
          </div>
          <div className="text-xs text-quiet mb-3">
            {user?.email} · <span className="font-mono uppercase">{user?.role}</span>
          </div>
          <button
            data-testid="logout-button"
            onClick={() => {
              logout();
              navigate("/login");
            }}
            className="w-full text-left text-xs text-quiet hover:text-ink border border-rule px-3 py-2 hover:bg-paper transition-colors"
          >
            Sign out →
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Toaster position="top-right" />
    </div>
  );
}
